import styled from 'styled-components';

import { Buttons } from './buttons';

/**
 * Panel specific buttons
 */
const PanelButtons = styled(Buttons)`
  position: absolute;
  bottom: 0;
`;

export {
  PanelButtons,
};
